export enum SectionMessagesEnum {
  VehicleNotFound1 = 'Wprowadź dane pojazdu ręcznie.',
  VehicleNotFound2 = 'Chcesz wyszukać pojazd raz jeszcze? ',
  VehicleNotFound3 = 'Rozpocznij od nowa',
  WeFoundYourVehicle1 = 'Odnaleźliśmy Twój pojazd o nr rejestracyjnym ',
  WeFoundYourVehicle2 = 'Jeżeli pojazd się nie zgadza, ',
  WeFoundYourVehicle3 = 'wprowadź dane ręcznie',
}
